import { useMutation, QueryClient } from "react-query";
import { deleteSeason } from "@/api/Customer/customer-form-api";

export function useSeasonDelete() {
	const queryClient = new QueryClient();

	return useMutation({
		mutationFn: (params) => deleteSeason(params),
		onSuccess: (_response) => {
			queryClient.invalidateQueries("dashboard_filters");
		},
	});
}
